import {
  CountryCityLocation,
  IpifyGeoClient,
  getCountry,
  getCountryCity,
} from "@redotech/ipify-client";
import { useRequiredContext } from "@redotech/react-util/context";
import { IpifyGeoClientContext } from "@redotech/redo-web/ipify";
import { useMemo } from "react";

export class LocationManager {
  constructor(private readonly ipifyGeoClient: IpifyGeoClient) {}

  async getCountry(signal: AbortSignal): Promise<string> {
    /* TODO(paul): Geocode coordinates from browser, if available
    try {
      const permission = await navigator.permissions.query({ name: 'geolocation'});
      if (permission.state === 'granted') {
        const position = await new Promise<GeolocationPosition>((resolve, reject) => navigator.geolocation.getCurrentPosition(resolve, reject));
        position.coords;
      }
    } catch {
      // Ignore errors
    }
    */
    let countryCodeForUser: string;
    try {
      const storage = sessionStorage.getItem("country_code");
      const data = JSON.parse(storage!);
      // cache for 10 minutes
      if (
        !data?.updatedAt ||
        Number(new Date(data.updatedAt)) < Date.now() - 1000 * 60 * 10
      ) {
        throw new Error("expired");
      }
      countryCodeForUser = data.value;
    } catch {
      const response = await getCountry(this.ipifyGeoClient, { signal });
      countryCodeForUser = response.location.country;
      try {
        sessionStorage.setItem(
          "country_code",
          JSON.stringify({
            updatedAt: new Date().toISOString(),
            value: countryCodeForUser,
          }),
        );
      } catch {
        // Ignore errors
      }
    }
    return countryCodeForUser;
  }

  async getDetailedLocation(signal: AbortSignal): Promise<CountryCityLocation> {
    let locationForUser: CountryCityLocation;

    try {
      const storage = sessionStorage.getItem("location");
      const data = JSON.parse(storage!);
      // cache for 10 minutes
      if (
        !data?.updatedAt ||
        Number(new Date(data.updatedAt)) < Date.now() - 1000 * 60 * 10
      ) {
        throw new Error("expired");
      }
      locationForUser = data.value;
    } catch {
      const response = await getCountryCity(this.ipifyGeoClient, { signal });
      locationForUser = response.location;
      try {
        sessionStorage.setItem(
          "location",
          JSON.stringify({
            updatedAt: new Date().toISOString(),
            value: locationForUser,
          }),
        );
      } catch {
        // Ignore errors
      }
    }
    return locationForUser;
  }
}

export function useLocationManager(): LocationManager {
  const ipifyGeoClient = useRequiredContext(IpifyGeoClientContext);
  return useMemo(() => new LocationManager(ipifyGeoClient), [ipifyGeoClient]);
}
